module.exports = __webpack_public_path__ + "img/14.e2a867f3.jpg";